import type { RouteLocationNormalized } from 'vue-router'
import { RouteName } from './routeNames'
import type { DeviceApi } from '@/libs/deviceApi/deviceApi'
import { getEnv } from '@/libs/env'
import { shouldApplyRouteGuard } from './noRouteGuardsRoutes'

const skippedRoutes = [
  RouteName.UpdateRequired,
  RouteName.Maintenance,
  RouteName.ErrorClientUnsupported
]

function shouldSkipGuard(to: RouteLocationNormalized): boolean {
  for (const routeName of skippedRoutes) {
    if (routeName === to.name) {
      return true
    }
  }
  return false
}

/**
 * Creates a navigation guard that enforces the rewardsOnlyOnSdk policy.
 *
 * This guard redirects users based on the device type and client name when
 * the rewardsOnlyOnSdk environment variable is enabled.
 */
export const buildRewardsOnlyOnSdkRouteGuard =
  (deviceApi: DeviceApi) => (to: RouteLocationNormalized) => {
    // Skip guard for routes that don't require protection
    if (!shouldApplyRouteGuard(to)) return
    if (shouldSkipGuard(to)) return

    if (!getEnv('rewardsOnlyOnSdk') || deviceApi.type === 'sdk') {
      return
    }

    // Apply the same logic as in App.vue
    if (deviceApi.type === 'web') {
      // Redirect web users to client unsupported page
      return { name: RouteName.ErrorClientUnsupported }
    }

    // Redirect users to update required page
    return { name: RouteName.UpdateRequired }
  }
